export default __webpack_public_path__ + "static/media/Apache 200_FI.9050ce6e.pdf";